<template>
  <fieldset v-if="showComponent">
    <div class="consent-stellantis" :class="{'consent-stellantis--last': isLast}">
      <p><strong>{{ titleReplaced }}</strong></p>
      <p>Outside of helping you with your enquiry, we would like to keep you updated on our latest news, promotions and tailored messaging. If you would like us to do this, you can sign up by providing your consent below. Consents provided here only relate to future marketing and will not impact us helping you with your current request. And no worries! You'll be able to change your mind at any time directly at <a href="https://privacyportal.stellantis.com/" target="_blank" rel="noopener noreferrer">https://privacyportal.stellantis.com</a>.
      </p>

      <!-- Stay in touch -->
      <div class="consent-stellantis__block">
        <div class="consent-stellantis__options">
          <div class="consent-stellantis__question">
            <a href="javascript:void(0)" @click.prevent="toggleAccordion(0)">
              Stay In Touch
            </a>
          </div>
          <div class="consent-stellantis__option">
            <input
              id="stellantisStayInTouchConsent"
              type="radio"
              name="stellantisStayInTouchGroup"
              value="I consent"
              @click="setConsent('StayInTouch', true)"
              v-validate="'required'"
              :data-vv-scope="validationScope"
              :class="getValidationClass('stellantisStayInTouchGroup', 'input')" />
            <label
              for="stellantisStayInTouchConsent"
              :class="getValidationClass('stellantisStayInTouchGroup', 'label')">
              I consent
            </label>
          </div>
          <div class="consent-stellantis__option">
            <input
              id="stellantisStayInTouchNoConsent"
              type="radio"
              name="stellantisStayInTouchGroup"
              value="I do not consent"
              @click="setConsent('StayInTouch', false)"
              v-validate.initial="'required'"
              :data-vv-scope="validationScope"
              :class="getValidationClass('stellantisStayInTouchGroup', 'input')" />
            <label
              for="stellantisStayInTouchNoConsent"
              :class="getValidationClass('stellantisStayInTouchGroup', 'label')">
              I do not consent
            </label>
          </div>
        </div>
        <span
          class="tla-form-group__message consent-stellantis__error"
          :class="[getValidationClass('stellantisStayInTouchGroup', 'message'), { 'tla-form-group__message consent-stellantis__error--open': !termsAndConditions[0].isCollapsed }]">
          Please select an option.
        </span>

        <div
          v-if="!termsAndConditions[0].isCollapsed"
          v-html="termsAndConditions[0].content">
        </div>
      </div>

      <!-- Get better details -->
      <div class="consent-stellantis__block">
        <div class="consent-stellantis__options">
          <div class="consent-stellantis__question">
            <a href="javascript:void(0)" @click.prevent="toggleAccordion(1)">
              Get Better Deals
            </a>
          </div>
          <div class="consent-stellantis__option">
            <input
              id="stellantisGetBetterDealsConsent"
              type="radio"
              name="stellantisGetBetterDealsGroup"
              value="I consent"
              @click="setConsent('GetBetterDeals', true)"
              v-validate="'required'"
              :data-vv-scope="validationScope"
              :class="getValidationClass('stellantisGetBetterDealsGroup', 'input')" />
            <label
              for="stellantisGetBetterDealsConsent"
              :class="getValidationClass('stellantisGetBetterDealsGroup', 'label')">
              I consent
            </label>
          </div>
          <div class="consent-stellantis__option">
            <input
              id="stellantisGetBetterDealsNoConsent"
              type="radio"
              name="stellantisGetBetterDealsGroup"
              value="I do not consent"
              @click="setConsent('GetBetterDeals', false)"
              v-validate.initial="'required'"
              :data-vv-scope="validationScope"
              :class="getValidationClass('stellantisGetBetterDealsGroup', 'input')" />
            <label
              for="stellantisGetBetterDealsNoConsent"
              :class="getValidationClass('stellantisGetBetterDealsGroup', 'label')">
              I do not consent
            </label>
          </div>
        </div>
        <span
          class="tla-form-group__message consent-stellantis__error"
          :class="[getValidationClass('stellantisGetBetterDealsGroup', 'message'), { 'tla-form-group__message consent-stellantis__error--open': !termsAndConditions[1].isCollapsed }]">
          Please select an option.
        </span>

        <div
          v-if="!termsAndConditions[1].isCollapsed"
          v-html="termsAndConditions[1].content">
        </div>
      </div>

      <!-- Join our Partners -->
      <div class="consent-stellantis__block">
        <div class="consent-stellantis__options">
          <div class="consent-stellantis__question">
            <a href="javascript:void(0)" @click.prevent="toggleAccordion(2)">
              Join our Partners
            </a>
          </div>
          <div class="consent-stellantis__option">
            <input
              id="stellantisJoinOurPartnersConsent"
              type="radio"
              name="stellantisJoinOurPartnersGroup"
              value="I consent"
              @click="setConsent('JoinOurPartners', true)"
              v-validate="'required'"
              :data-vv-scope="validationScope"
              :class="getValidationClass('stellantisJoinOurPartnersGroup', 'input')" />
            <label
              for="stellantisJoinOurPartnersConsent"
              :class="getValidationClass('stellantisJoinOurPartnersGroup', 'label')">
              I consent
            </label>
          </div>
          <div class="consent-stellantis__option">
            <input
              id="stellantisJoinOurPartnersNoConsent"
              type="radio"
              name="stellantisJoinOurPartnersGroup"
              value="I do not consent"
              @click="setConsent('JoinOurPartners', false)"
              v-validate.initial="'required'"
              :data-vv-scope="validationScope"
              :class="getValidationClass('stellantisJoinOurPartnersGroup', 'input')" />
            <label
              for="stellantisJoinOurPartnersNoConsent"
              :class="getValidationClass('stellantisJoinOurPartnersGroup', 'label')">
              I do not consent
            </label>
          </div>
        </div>
        <span
          class="tla-form-group__message consent-stellantis__error"
          :class="[getValidationClass('stellantisJoinOurPartnersGroup', 'message'), { 'tla-form-group__message consent-stellantis__error--open': !termsAndConditions[2].isCollapsed }]">
          Please select an option.
        </span>

        <div
          v-if="!termsAndConditions[2].isCollapsed"
          v-html="termsAndConditions[2].content">
        </div>
      </div>

      <p>
        By submitting this information:
        <ul>
          <li>You are agreeing to the collecting and processing of your personal data and sharing it with the appropriate Retailer so they can facilitate your request and follow up with you.</li>
          <li>You are confirming you have read and understood the <a :href="getPrivacyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and consent to the processing of your information as described in it and your marketing preferences indicated above.</li>
        </ul>
      </p>
    </div>
  </fieldset>
</template>
<script lang="ts">
import VeeValidate, {
  Validator
} from 'vee-validate';
import {
  Component,
  Prop,
  Vue,
  Inject,
  Watch
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';
import { tokenService } from '@/services/TokenService';
import Accordion from '../../viewmodels/Accordion';
import ExtraData from '../../models/ExtraData';
import { validationService } from '../../services/ValidationService';
import OptInData from '../../models/OptInData';

const EnquiryModule = namespace('enquiryModule');

Vue.use(VeeValidate);

@Component
export default class StellantisConsentComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @EnquiryModule.Action public submitOptInConsent;

  @Prop({ default: 'manufacturerName (Stellantis S.p.A) Consent' })
  public title!: string;

  // These are the FCA and PSA manufacturer IDs
  @Prop({ default: () => [91, 1, 10, 105, 97, 18, 109, 9, 147, 39, 126, 56, 135, 190] })
  public allowedManufacturerIds!: number[];

  @Prop({ default: '' })
  public privacyNoticeLinkURL!: string;

  @Prop({ default: false })
  public isLast!: boolean;

  @Prop({ default: null })
  public validationScope!: string;

  public termsAndConditions: Accordion[] = [];

  private optInData: OptInData = new OptInData();

  public get titleReplaced(): string {
    return tokenService.replaceToken(this.title);
  }

  public get showComponent(): boolean {
    const currentVehicle = this.$store.getters['vehicleModule/currentVehicle'];

    return currentVehicle !== null
      && this.allowedManufacturerIds.includes(currentVehicle.manufacturerId)
      && this.termsAndConditions.length > 0;
  }

  public toggleAccordion(index: number) {
    this.termsAndConditions.forEach((item, i) => {
      if (i === index && !item.isCollapsed) {
        item.isCollapsed = true;
      } else {
        item.isCollapsed = i !== index;
      }
    });
  }

  public setConsent(option: string, consentGiven: (boolean | null)) {
    const key = this.createExtraDataKey(option);
    const extraData: ExtraData = new ExtraData(key, `${consentGiven}`);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
  }

  public createExtraDataKey(option: string): string {
    const slug = option.replace(/ /g, '');
    return `StellantisConsent${slug}`;
  }

  public mounted() {
    this.setTermsAndConditions();
  }

  public get currentManufacturerId(): string {
    const currentVehicle = this.$store.getters['vehicleModule/currentVehicle'];

    if (currentVehicle) {
      return `${currentVehicle.manufacturerId}`;
    }

    return '';
  }

  @Watch('currentManufacturerId')
  public setTermsAndConditions() {
    this.termsAndConditions = [
      new Accordion(
        'Stay In Touch',
        this.replaceLinks('We like to maintain our relationship with you and only you! Get offers, promotions, events and other cool content from our brands. Let\'s stay in touch! If you want to know more about what we will do with your data, please look on the section 4.c) to our: {{Privacy policy}}. And no worries! You\'ll be able to change your mind at any time directly at {{Preference Centre}}.')
      ),
      new Accordion(
        'Get Better Deals',
        this.replaceLinks('Let\'s get to know each other! We want to tailor your experience with us by taking note of your specific needs, what you like or don\'t like! We would be delighted if you allow us to understand what you enjoy, read and do with us so that we can offer you better and personalized deals. If you want to know more about what we will do with your data please look on the section 4.f) in our: {{Privacy policy}}. And no worries! You\'ll be able to change your mind at any time directly at {{Preference Centre}}.')
      ),
      new Accordion(
        'Join Our Partners',
        this.replaceLinks('We are a big community that shares interesting things together! If you would like to meet our incredible partners and allow them to communicate directly with you, opt-in! If you want to know more about what we will do with your data please look on the section 4.h) in our: {{Privacy policy}}. And no worries ! You\'ll be able to change your mind at any time directly at {{Preference Centre}}.')
      )
    ];

    if (this.showComponent) {
      this.populateConsentAndSubmit();
    }
  }

  public get getPrivacyUrl(): string {
    if (this.privacyNoticeLinkURL.length > 0) {
      return this.privacyNoticeLinkURL;
    }

    const currentVehicle = this.$store.getters['vehicleModule/currentVehicle'];

    if (currentVehicle !== null) {
      switch (currentVehicle.manufacturerId) {
        case 91:
          return 'https://www.abarthcars.co.uk/privacy-policy';
        case 1:
          return 'https://www.alfaromeo.co.uk/privacy-policies';
        case 10:
        case 105:
          return 'https://www.citroen.co.uk/tools/privacy-policy.html';
        case 97:
          return 'https://www.dsautomobiles.co.uk/tools/privacy-policy.html';
        case 18:
        case 109:
          return 'https://www.fiat.co.uk/tools/privacy-policy';
        case 9:
        case 147:
          return 'https://www.jeep.co.uk/privacy';
        case 39:
        case 126:
          return 'https://www.peugeot.co.uk/tools/privacy-policy.html';
        case 56:
        case 135:
          return 'https://www.vauxhall.co.uk/tools/privacy-policy.html';
        case 190:
          return 'https://www.leapmotor.net/uk/privacy-policy';
        default:
          break;
      }
    }

    return '';
  }

  private replaceLinks(text: string): string {
    text = text.replace(/\{{Privacy policy}}/g, `<a href="${this.getPrivacyUrl}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>`);
    text = text.replace(/\{{Preference Centre}}/g, '<a href="https://www.preferences.stellantis.com/" target="_blank" rel="noopener noreferrer">Preference Centre</a>');

    return text;
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService.getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public created() {
    if (this.showComponent) {
      this.populateConsentAndSubmit();
    }
  }

  public populateConsentAndSubmit() {
      // Set the policy type to be Partners
      this.optInData.PolicyType = 3;

      // This is the GUID from the Privacy Policy Manager
      this.optInData.PublishedPolicyId = 'fe0e7f67-6688-4d3e-a075-aa1835241417';

      this.submitOptInConsent(this.optInData);
  }
}
</script>
